var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alarmTrend flex1 flexGrow1"},[_c('div',{staticClass:"cardStyle",staticStyle:{"height":"249px"},attrs:{"id":"alarmTrend"}})])}]

export { render, staticRenderFns }